import React from 'react'
import Manager from '../../public/components/Manager'
import BonusApplicationDeatil from './BonusApplicationDeatil'
Ext.require('Ext.Toast')

const config = {
    buttons: [
    ],
    columns: [
        { _text: '奖金期号', minWidth: 250, search: true, },
        { _text: '申请人', field: 'Creator', minWidth: 150, search: true, },
        { _date: '申请日期', field: 'CreateTime', minWidth: 150, filter: true, align: 'left'},
        { _int: '人数', minWidth: 150, filter: true, },
        { _text: '申请原因', minWidth: 150, flex: 10, search: true },
        { _text: '状态名称', minWidth: 150, search: true,filter:['select'], },
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
        showDetail(props => <BonusApplicationDeatil {...props} id={data.id} readOnly={true} />)
    }
}

export default props => <Manager {...props} config={config} />